/* IceRoyale: wspolny licznik tygodniowy, strefa Europe/Warsaw.
   Pokazuje czas do konca aktualnego tygodnia; reset w poniedzialek 00:00.
   Wazne: promocje w Shopify musza byc faktycznie aktywne w kazdym tygodniu. */
(function(){
 'use strict';
 var zone='Europe/Warsaw';
 var partsFormatter=new Intl.DateTimeFormat('en-GB',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 function parts(date){var out={};partsFormatter.formatToParts(date).forEach(function(p){if(p.type!=='literal')out[p.type]=Number(p.value);});return out;}
 function zonedToUtc(y,m,d,h){
  var desired=Date.UTC(y,m-1,d,h||0,0,0),candidate=desired;
  for(var i=0;i<3;i++){var p=parts(new Date(candidate));var local=Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);candidate+=desired-local;}
  return candidate;
 }
 function secondsToMonday(){
  var now=new Date(),p=parts(now),weekday=new Date(Date.UTC(p.year,p.month-1,p.day)).getUTCDay();
  var days=(8-weekday)%7;if(days===0)days=7;
  var next=new Date(Date.UTC(p.year,p.month-1,p.day+days));
  return Math.max(0,Math.floor((zonedToUtc(next.getUTCFullYear(),next.getUTCMonth()+1,next.getUTCDate(),0)-now.getTime())/1000));
 }
 function pad(n){return String(n).padStart(2,'0');}
 function tick(){
  var s=secondsToMonday(),d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60),sec=s%60;
  document.querySelectorAll('[data-ir-offer-timer]').forEach(function(el){var out=el.querySelector('[data-ir-time]');if(out){el.hidden=false;out.textContent=pad(d)+' dni · '+pad(h)+' godz. · '+pad(m)+' min · '+pad(sec)+' sek.';}});
  document.querySelectorAll('.irdi__timer').forEach(function(el){el.hidden=false;var grid=el.querySelector('.irdi__timer-grid'),expired=el.querySelector('.irdi__timer-expired');if(grid)grid.hidden=false;if(expired)expired.hidden=true;var values={days:d,hours:h,minutes:m,seconds:sec};Object.keys(values).forEach(function(k){var target=el.querySelector('[data-time="'+k+'"]');if(target)target.textContent=pad(values[k]);});});
  document.querySelectorAll('.ir-promo [data-countdown]').forEach(function(el){el.textContent=(d?d+'D ':'')+pad(h)+':'+pad(m)+':'+pad(sec);});
 }
 function start(){tick();setInterval(tick,1000);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
